import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from "@angular/router";
import {CurrentRouteService} from "../currentRoute.service";
import { ForgotPasswordService } from './forgot-password.service';0

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  myForm: UntypedFormGroup;
  is_form_error: boolean = false;
  form_error_message:string = '';
  is_loading = false;

  constructor(private forgotPasswordService: ForgotPasswordService,
              private fb: UntypedFormBuilder,
              public router: Router,
              private route: ActivatedRoute,
              private currentrouteService: CurrentRouteService,) { }

  ngOnInit(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.currentrouteService.announceCurrentRoute(this.router.url);
    this.myForm = this.fb.group({
      email: ['', Validators.required]
    })//end myForm

  }

  onFocus(){
    this.is_form_error = false;
    this.form_error_message = null;
  }

  onSubmit(){

    this.is_loading = true;
    let endpoint = 'password-forgot';
    this.forgotPasswordService.forgotPassword(endpoint,this.myForm.value.email).subscribe(
      data => {
        console.log(data);
        this.is_loading = false;
        this.router.navigate(['/forgot-password-confirmation']);
      },
      error => {
        this.is_loading = false;
        console.log('WOW',error);
        this.is_form_error = true;
        this.form_error_message = error
      }
    );
  }

} //end of class
